import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AssistantGrant';
const ENDPOINT = `/assistant-grants/`;

/**
 * Assistants IA connectés au dossier (#1312). Le serveur réduit la liste de lui-même :
 * toutes les autorisations du dossier pour qui gère les clés API, les siennes sinon.
 * La révocation passe par la suppression (`deleted = true` puis `save$`).
 */
@Injectable({
    providedIn: 'root'
})
export class AssistantGrantService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
